<template>
  <v-card>
    <feedback-header :feedback="feedback"></feedback-header>
    <v-divider></v-divider>
    <feedback-form v-if="editMode" :feedback="feedback" @cancel="editMode = false"></feedback-form>
    <feedback-content v-else :feedback="feedback"></feedback-content>
    <v-divider></v-divider>
    <feedback-actions :feedback="feedback" v-model="editMode"></feedback-actions>
  </v-card>
</template>

<script>
  import FeedbackHeader from '@/components/FeedbackHeader.vue'
  import FeedbackForm from '@/components/FeedbackForm.vue'
  import FeedbackContent from '@/components/FeedbackContent.vue'
  import FeedbackActions from '@/components/FeedbackActions.vue'
  export default {
    components: {
      FeedbackHeader,
      FeedbackForm,
      FeedbackContent,
      FeedbackActions
    },
    props: {
      feedback: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        editMode: false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/FeedbackCard.vue